import Joi from 'joi';

import { ALL_POSSIBLE_ROLES } from '../../../../user/roles/simplify-roles';

export const possibleRolesSchema = () => Joi.array().items(...ALL_POSSIBLE_ROLES);
